import { map } from 'lodash'
import { success, error } from '@/utils/alert'
import moment from 'moment'

export default {
  formatDate (date) {
    return moment(date).format('DD/MM')
  },
  doConfirmedAll () {
    const ids = map(this.schedules, schedule => {
      return schedule.id
    })

    this.$resource.put(ids.toString() + '/reserved')
      .then(({data}) => {
        success('Horário(s) confirmado como reservado com sucesso.')
        this.$emit('close', data)
      })
      .catch(() => {
        error('Ocorreu um erro ao confirmar este horário.')
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/schedulings/components/reserved/resources/methods.js